<template>
  <div class="module-container">
    <div class="title">证件信息</div>
    <ul class="infos">
      <li class="info-item">
        <div class="name">姓名</div>
        <div class="value">{{ infos.name }}</div>
      </li>
      <li class="info-item">
        <div class="name">性别</div>
        <div class="value">{{ formatSexText(infos.sex) }}</div>
      </li>
      <li class="info-item">
        <div class="name">民族</div>
        <div class="value">{{ infos.nation }}</div>
      </li>
      <li class="info-item">
        <div class="name">出生日期</div>
        <div class="value">{{ infos.date }}</div>
      </li>
      <li class="info-item">
        <div class="name">居民身份证号码</div>
        <div class="value">{{ infos.idcard }}</div>
      </li>
      <li class="info-item">
        <div class="name">签发机关</div>
        <div class="value">{{ infos.releaseOrg }}</div>
      </li>
      <li class="info-item">
        <div class="name">签证日期</div>
        <div class="value">{{ infos.releaseAt }}</div>
      </li>
      <li class="info-item">
        <div class="name">户籍所在地</div>
        <div class="value">{{ infos.registeredResidence }}</div>
      </li>
      <li class="info-item">
        <div class="name">申领地地址</div>
        <div class="value">{{ infos.receivePlace }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          name: '',
          sex: '',
          nation: '',
          date: '',
          idcard: '',
          releaseOrg: '',
          releaseAt: '',
          registeredResidence: '',
          receivePlace: ''
        }
      }
    }
  },
  methods: {
    formatSexText(val) {
      if (val == 1) {
        return '男'
      } else if (val == 0) {
        return '女'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.module-container {
  padding 30px
  font-family PingFangSC-Semibold, PingFang SC
  font-weight 400
  .title {
    height 53px
    font-size 38px
    font-weight 600
    color #333333
    line-height 53px
    padding-left 20px
    position relative
    z-index 5
    &::before {
      z-index -1
      position absolute
      content ''
      left 0
      top 50%
      transform translateY(-50%)
      width 36px
      height 36px
      border-radius 50%
      background linear-gradient(270deg, #DBEBFF 0%, #7DB7FF 100%)
    }
  }
  .infos {
    .info-item {
      display flex
      justify-content space-between
      align-items center
      padding 30px 0
      font-size 30px
      line-height 42px
      .name {
        width 210px
        margin-right 50px
        color #333333
      }
      .value {
        text-align right
        flex 1
        color #999999
      }
    }
    .info-item+.info-item {
      border-top 1px solid #ECECEC
    }
  }
}
</style>
